<template>
  <div class="colorpickerContainer">
    <div
      :key='index'
      @click="changeSelectedColor(color)"
      :class="{'active': color === activeColor,'colorpicker':true}"
      :style="{'background-color': color}"
      v-for="(color, index) in colors"
    ></div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  name: 'colorPicker',
  data: function () {
    return {
      activeColor: '',
      colors: []

    }
  },
  computed: {
    // colors () {
    //   console.log(JSON.parse(this.current.colours))

    //   return JSON.parse(this.current.colours)
    // },
    ...mapState({
      currentSelectedColor: 'currentSelectedColor',
      current: 'current'
    })
  },
  watch: {
    currentSelectedColor: {
      handler (currentSelectedColor) {
        this.changeSelectedColor(currentSelectedColor)
      },
      deep: true,
      immediate: true
    }
  },
  created: function () {
    this.activeColor = this.colors[0]
    this.$store.commit('board/CHANGE_POST_COLOR', this.activeColor)
  },
  mounted () {
    let getColors = () => {
      setTimeout(() => {
        if (this.current.colours) {
          // console.log(this.current.colours)
          this.colors = JSON.parse(this.current.colours)
          while (typeof this.colors !== 'object') {
            this.colors = JSON.parse(this.colors)
          }
          this.activeColor = this.colors[0]

          // console.log(this.activeColor)

          this.$store.commit('board/CHANGE_POST_COLOR', this.activeColor)
        } else {
          getColors()
        }
      }, 800)
    }

    getColors()
  },
  methods: {
    changeSelectedColor: function (color) {
      this.activeColor = color
      this.$store.commit('board/CHANGE_POST_COLOR', this.activeColor)
    }
  }
}
</script>

<style scoped>
.colorpicker {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: inline-block;
  margin: 0px 10px 0 0;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.active {
  border: 3px solid black;
}

.colorpickerContainer {
  width: 100%;
  margin: auto;
  text-align: center;
  padding: 0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/board/toolbar/colorPicker.vue